import React, { useState } from 'react';

import Link from '@skippay/core/components/Link';
import Modal from '@skippay/core/components/Modal';
import Step from '@skippay/core/components/Step';
import CheckboxField from '@skippay/core/form-fields/CheckboxField';
import { FormattedMessage, useIntl } from '@skippay/core/i18n/intl';

import { PARTNERS } from 'constants/routes';
import ExtendedMarketingModal from 'modals/ExtendedMarketingModal';

function MarketingExtendedConsentCheckboxField(props) {
	const [dataProcessingModalOpen, setDataProcessingModalOpen] = useState(false);
	const intl = useIntl();

	return (
		<>
			<CheckboxField
				alignTop
				label={
					<>
						<Step v xxxs />
						<FormattedMessage
							defaultMessage="Souhlasím se {linkPersonalDataProcessing} pro&nbsp;účely zasílání novinek od nás i našich {linkPartners}."
							id="MarketingExtendedConsentCheckboxField.fieldLabelSlugMarketingExtended"
							values={{
								linkPersonalDataProcessing: (
									<Link
										onClick={() => setDataProcessingModalOpen(true)}
										testId="personalDataProcessing"
										analyticsId="personalDataProcessing"
									>
										<FormattedMessage
											defaultMessage="zpracováním osobních údajů"
											id="MarketingExtendedConsentCheckboxField.linkPersonalDataProcessing"
										/>
									</Link>
								),
								linkPartners: (
									<Link to={PARTNERS} testId="partners" analyticsId="partners" isExternal>
										<FormattedMessage
											defaultMessage="partnerů"
											id="MarketingExtendedConsentCheckboxField.partners"
										/>
									</Link>
								),
							}}
						/>
					</>
				}
				{...props}
			/>
			<Modal
				contentLabel={intl.formatMessage({
					defaultMessage: `Více o zpracování osobních údajů`,
					id: `MarketingExtendedConsentCheckboxField.ExtendedMarketingModal.contentLabel`,
				})}
				isOpen={dataProcessingModalOpen}
				onRequestClose={() => setDataProcessingModalOpen(false)}
			>
				<ExtendedMarketingModal modalClose={() => setDataProcessingModalOpen(false)} />
			</Modal>
		</>
	);
}

export default MarketingExtendedConsentCheckboxField;
